import {Artikel} from './artikel';
import {ArtikelAktion} from './artikel-aktion';

export class ArtikelWithAktionen {
  artikel: Artikel;
  aktionen: ArtikelAktion[];
}
